export const aciGift = {
    iconName: 'gift',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M19.49 12.006H3.89v8.4a1.2 1.2 0 001.2 1.2h13.2a1.2 1.2 0 001.2-1.2v-8.4z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M19.494 8.406h-15.6a1.2 1.2 0 00-1.2 1.2v1.8a.6.6 0 00.6.6h16.8a.6.6 0 00.6-.6v-1.8a1.2 1.2 0 00-1.2-1.2zM11.09 8.406c-2.651 0-5.4-2.15-5.4-4.8M5.69 3.606c2.651 0 5.4 2.149 5.4 4.8M12.29 8.406c2.651 0 5.4-2.15 5.4-4.8M17.69 3.606c-2.651 0-5.4 2.149-5.4 4.8',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M9.894 8.406h3.6v13.2h-3.6v-13.2z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
